import { render, staticRenderFns } from "./StudentLevelModified.vue?vue&type=template&id=c7e58680&scoped=true&"
import script from "./StudentLevelModified.vue?vue&type=script&lang=js&"
export * from "./StudentLevelModified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e58680",
  null
  
)

export default component.exports